module.exports = __webpack_public_path__ + "img/tech8small.09685928.jpg";